<template>
    <v-dialog v-model="localDialog" width="35%" @update:modelValue="updateDialog" transition="" persistent :open-delay="0" :close-delay="0">
        <base-card
      :title="isEntryMode ? 'Add Employee Bank Setup' : 'Update Employee Bank Setup'"
      :v-card-text-class="'pa-4'"
    >
<v-form @submit.prevent="submit" ref="EmployeeBankSetup">
                    <v-row>
                        <v-col cols="12"> 

                            <v-text-field
                                density="compact"
                                variant="outlined"
                                bg-color="grey-lighten-4"
                                v-model="name.value.value"
                                :error-messages="name.errorMessage.value"
                                clearable
                            >
                                <template #label>
                                    Employee Bank Name
                                    <span class="text-red-accent-4">*</span>
                                </template>
                            </v-text-field>

                            <v-number-input 
                                control-variant="hidden"
                                density="compact"
                                variant="outlined"
                                bg-color="grey-lighten-4"
                                v-model="sl.value.value"
                                :error-messages="sl.errorMessage.value"
                                clearable
                            >   
                                <template #label>
                                    Sequence
                                    <span class="text-red-accent-4">*</span>
                                </template>
                            </v-number-input>

                            <v-text-field
                                label="Remarks"
                                density="compact"
                                variant="outlined"
                                bg-color="grey-lighten-4"
                                v-model="remarks.value.value"
                                :error-messages="remarks.errorMessage.value"
                                clearable
                            ></v-text-field>

                            <v-checkbox                            
                                label="Active"
                                v-model="status.value.value"
                                :error-messages="status.errorMessage.value"
                                density="compact"
                                variant="outlined"
                                hide-details
                                color="primary"
                                value="1"
                            ></v-checkbox>
                            <input v-model="bank_id.value.value" type="hidden">
                        </v-col>
                    </v-row>

                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-layout class="justify-end">
                            <v-btn class="bg-red" variant="flat" type="reset"@click="closeDialog">Close</v-btn>

                            <v-btn 
                            class="bg-brand w-15 ms-2"  
                            variant="flat" 
                            type="submit"
                            >
                            {{ isEntryMode ? 'Save' : 'Update' }}
                            </v-btn>
                        </v-layout>
                    </v-card-actions>

                </v-form>
            </base-card>
    </v-dialog>
</template>

<script>
import baseCard from '@/components/utils/baseCard.vue';
import { ref, watch } from 'vue'
import { useStore } from 'vuex'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import { toast } from 'vue3-toastify'

export default {
  components: { baseCard },
    name: 'EmployeeBankSetup',
    props: {
        dialog: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object,
            default: () => ({
                name: '',
                sl: null,
                remarks: '',
                status: 1,
                bank_id: null,
            })
        }
    },
    data() {
        return {
            localDialog: this.dialog,
            errorMessages: '',
            loading: false,
            isEntryMode: true,
            departmentList: [],
        }
    },
    computed: {},
    watch: {
        dialog(val) {
            this.localDialog = val
        },
        localDialog(val) {
            this.$emit('update:dialog', val)
        },
        data: {
            handler(newData) {
                this.isEntryMode = !newData.id;
                this.resetForm({ errors: {}, touched: {} });
                this.name.setValue(newData.name || '', false);
                this.sl.setValue(newData.sl || null, false);
                this.remarks.setValue(newData.remarks || '', false);
                this.status.setValue(String(newData.status) || '1', false);
                this.bank_id.setValue(newData.id || '', false);
            },
        }

    },
    created() {},
    methods: {
        updateDialog(val) {
            this.$emit('update:dialog', val)
        },
        closeDialog() {
            this.$emit('update:dialog', false);
        },
    },
    setup(props, { emit }){
        const { handleSubmit, resetForm} = useForm({
            validationSchema: yup.object({
            name: yup.string().min(1).max(50).required().trim().label('Name'),
            sl: yup.number().required().label('Sequence'),
            remarks: yup.string().nullable().label('remarks')
            }),
        });

        const name = useField('name');
        const sl = useField('sl');
        const department_id = useField('department_id');
        const remarks = useField('remarks');
        const status = useField('status');
        const bank_id = useField('bank_id');
        const errorMessages = ref('');
        const loading  = ref('');
        const store = useStore();

        const submit = handleSubmit((values) => {

            store.dispatch("saveUpdateHrmEmployeeBankSetup", values)
                .then((response) => {
                    resetForm();
                    emit('update:dialog', false);
                    toast.success(response.data.message);
                    loading.value = true;
                    store.dispatch('getHrmEmployeeBankSetupList')
                        .then(data => {
                            loading.value = false;
                        })
                        .catch(error => {
                            loading.value = false;
                            toast.error(error.response.data.message);
                        })
                })
                .catch((error) => {            
                    toast.error(error.response.data.message);          
                })
        });
        return {
            submit,
            remarks,
            name,
            sl,
            department_id,
            status,
            errorMessages,
            bank_id,
            resetForm,
            loading
        }
    },
    mounted() {}
}
</script>